module.exports = __webpack_public_path__ + "img/qrCode.c23175c7.jpg";